<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="storage w">
    <Row class="component-title">
      <Col span="24">我要存数据</Col>
    </Row>
    <Row class="storage-content">
      <Col span="12" class="h-full content-image">.</Col>
      <Col span="12" class="h-full relative content-text">
        <div class="h-auto w-full">
          <div class="detail-text">
            <h6>数据归档服务</h6>
            <div class="bars">
              <span class="inline-block bar h-full"></span>
            </div>
            <div class="detail-content">
              提供科学研究项目、样本、实验、测序等所对应的生物数据、信息和分析结果数据的存储和共享。
            </div>
          </div>
        </div>
      </Col>
    </Row>
    <Row class="component-title">
      <Col span="24" class="fs-28px">我怎么操作</Col>
    </Row>
    <div class="operation"></div>
  </div>
</template>

<script>
export default {
  name: 'storageComponent',
  props: {},
  mixins: [],
  components: {},
  data() {
    return {
      hooperSettings: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        // effect: 'fade',
        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.storage {
  .fs-28px {
    font-size: 1.46vw;
  }
  .component-title {
    padding: 4.6875vw 0 1.67vw; //90px 0 32px;
  }
  .storage-content {
    height: 15.89vw; //305px;
  }
  .content-image {
    background-image: url('/static/images/background/storage1.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 0.78vw 0 0 0.78vw; //15px 0 0 15px;
  }
  .content-text {
    border-radius: 0 0.78vw 0.78vw 0; //0 15px 15px 0;
    border: 1px solid #e2e3e5;
    padding: 4.17vw 5.73vw 0 4.375vw; //80px 110px 0 84px;
  }
  .detail-text {
    h6 {
      font-size: 1.46vw; //28px;
      line-height: 2vw; //39px;
      color: #111a2e;
      margin-bottom: 0.42vw; //8px;
    }
    .bars {
      height: 4px;
      margin-bottom: 2.08vw; //40px;
    }
    .bar {
      width: 2.7vw; //52px;
      background: #46bfb8;
      float: left;
    }
  }
  .detail-content {
    font-size: 0.83vw; //16px;
    line-height: 1.15vw; //22px;
    letter-spacing: 1px;
    color: #646a77;
  }
  .operation {
    height: 9.9vw; //190px;
    background-image: url('/static/images/background/operation.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 100%;
    margin-bottom: 5.625vw; //108px;
    margin-top: 3.4375vw; //66px;
  }
}
</style>
